import React, { useState } from 'react';
import DatePicker from '../../../Common/DatePicker';
import { formatDate } from '../../../../lib/employeeHelpers';
const StatutoryRatesManager = () => {
  const [showHistoryModal, setShowHistoryModal] = useState(false);
  const [selectedSection, setSelectedSection] = useState('');
  const [ptHistoryState, setPtHistoryState] = useState('Karnataka');
  const [showAddStateModal, setShowAddStateModal] = useState(false);
  const [newStateName, setNewStateName] = useState('');
  const [effectiveDates, setEffectiveDates] = useState({
    pf: new Date().toISOString().slice(0, 10),
    esi: new Date().toISOString().slice(0, 10),
    pt: new Date().toISOString().slice(0, 10),
    gratuity: new Date().toISOString().slice(0, 10),
    incomeTax: new Date().toISOString().slice(0, 10),
    incomeTaxOld: new Date().toISOString().slice(0, 10),
    incomeTaxNew: new Date().toISOString().slice(0, 10)
  });
  const [history, setHistory] = useState({
    pf: [
      { id: 1, date: '2024-01-01', changes: 'Initial PF rates setup', rates: { employeeShare: 12, employerShare: 12, ceiling: 15000, epf: 8.33, eps: 3.67, adminCharges: 0.5, edliRate: 0.5 } }
    ],
    esi: [
      { id: 1, date: '2024-01-01', changes: 'Initial ESI rates setup', rates: { employeeShare: 0.75, employerShare: 3.25, ceiling: 21000, cutoff: 21000 } }
    ],
    pt: {
      'Karnataka': [
        { id: 1, date: '2024-01-01', changes: 'Initial Karnataka PT rates setup', rates: { slabs: [{ min: 0, max: 15000, rate: 200 }, { min: 15001, max: 30000, rate: 250 }] } }
      ],
      'Maharashtra': [
        { id: 1, date: '2024-01-01', changes: 'Initial Maharashtra PT rates setup', rates: { slabs: [{ min: 0, max: 5000, rate: 0 }, { min: 5001, max: 10000, rate: 175 }] } }
      ],
      'Tamil Nadu': [
        { id: 1, date: '2024-01-01', changes: 'Initial Tamil Nadu PT rates setup', rates: { slabs: [{ min: 0, max: 21000, rate: 0 }, { min: 21001, max: Infinity, rate: 2500 }] } }
      ],
      'West Bengal': [
        { id: 1, date: '2024-01-01', changes: 'Initial West Bengal PT rates setup', rates: { slabs: [{ min: 0, max: 10000, rate: 110 }, { min: 10001, max: 15000, rate: 130 }] } }
      ],
      'Gujarat': [
        { id: 1, date: '2024-01-01', changes: 'Initial Gujarat PT rates setup', rates: { slabs: [{ min: 0, max: 5000, rate: 0 }, { min: 5001, max: 10000, rate: 200 }] } }
      ],
      'Delhi': [
        { id: 1, date: '2024-01-01', changes: 'Initial Delhi PT rates setup', rates: { slabs: [{ min: 0, max: 10000, rate: 0 }, { min: 10001, max: 20000, rate: 200 }] } }
      ]
    },
    gratuity: [
      { id: 1, date: '2024-01-01', changes: 'Initial Gratuity rates setup', rates: { rate: 4.81 } }
    ],
    incomeTax: [
      { id: 1, date: '2024-01-01', changes: 'Initial Income Tax rates setup', rates: { old: [{ min: 0, max: 250000, rate: 0 }], new: [{ min: 0, max: 300000, rate: 0 }], cess: 4 } }
    ],
    incomeTaxOld: [
      { id: 1, date: '2024-01-01', changes: 'Initial Old Regime Tax rates setup', rates: { cess: 4, slabs: [{ min: 0, max: 250000, rate: 0 }], surcharge: [{ min: 0, max: 5000000, rate: 0 }] } }
    ],
    incomeTaxNew: [
      { id: 1, date: '2024-01-01', changes: 'Initial New Regime Tax rates setup', rates: { cess: 4, slabs: [{ min: 0, max: 300000, rate: 0 }], surcharge: [{ min: 0, max: 5000000, rate: 0 }] } }
    ]
  });
  const [rates, setRates] = useState({
    pf: {
      employeeShare: 12,
      employerShare: 12,
      ceiling: 15000,
      epf: 8.33,
      eps: 3.67,
      adminCharges: 0.5,
      edliRate: 0.5
    },
    esi: {
      employeeShare: 0.75,
      employerShare: 3.25,
      ceiling: 21000,
      cutoff: 21000
    },
    pt: {
      currentState: 'Karnataka',
      states: {
        'Karnataka': [
          { min: 0, max: 15000, rate: 200 },
          { min: 15001, max: 30000, rate: 250 },
          { min: 30001, max: 50000, rate: 300 },
          { min: 50001, max: 100000, rate: 400 },
          { min: 100001, max: Infinity, rate: 500 }
        ],
        'Maharashtra': [
          { min: 0, max: 5000, rate: 0 },
          { min: 5001, max: 10000, rate: 175 },
          { min: 10001, max: 15000, rate: 200 },
          { min: 15001, max: Infinity, rate: 300 }
        ],
        'Tamil Nadu': [
          { min: 0, max: 21000, rate: 0 },
          { min: 21001, max: Infinity, rate: 2500 }
        ],
        'West Bengal': [
          { min: 0, max: 10000, rate: 110 },
          { min: 10001, max: 15000, rate: 130 },
          { min: 15001, max: 25000, rate: 150 },
          { min: 25001, max: Infinity, rate: 200 }
        ],
        'Gujarat': [
          { min: 0, max: 5000, rate: 0 },
          { min: 5001, max: 10000, rate: 200 },
          { min: 10001, max: Infinity, rate: 300 }
        ],
        'Delhi': [
          { min: 0, max: 10000, rate: 0 },
          { min: 10001, max: 20000, rate: 200 },
          { min: 20001, max: Infinity, rate: 300 }
        ]
      }
    },
    gratuity: {
      rate: 4.81
    },
    incomeTax: {
      cess: 4,
      surcharge: {
        old: [
          { min: 0, max: 5000000, rate: 0 },
          { min: 5000001, max: 10000000, rate: 10 },
          { min: 10000001, max: 20000000, rate: 15 },
          { min: 20000001, max: 50000000, rate: 25 },
          { min: 50000001, max: Infinity, rate: 37 }
        ],
        new: [
          { min: 0, max: 5000000, rate: 0 },
          { min: 5000001, max: 10000000, rate: 10 },
          { min: 10000001, max: 20000000, rate: 15 },
          { min: 20000001, max: 50000000, rate: 25 },
          { min: 50000001, max: Infinity, rate: 37 }
        ]
      },
      slabs: {
        old: [
          { min: 0, max: 250000, rate: 0 },
          { min: 250001, max: 500000, rate: 5 },
          { min: 500001, max: 1000000, rate: 20 },
          { min: 1000001, max: Infinity, rate: 30 }
        ],
        new: [
          { min: 0, max: 300000, rate: 0 },
          { min: 300001, max: 600000, rate: 5 },
          { min: 600001, max: 900000, rate: 10 },
          { min: 900001, max: 1200000, rate: 15 },
          { min: 1200001, max: 1500000, rate: 20 },
          { min: 1500001, max: Infinity, rate: 30 }
        ]
      }
    }
  });

  const handleRateChange = (category, field, value) => {
    setRates(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [field]: parseFloat(value) || 0
      }
    }));
  };

  const handleEffectiveDateChange = (section, date) => {
    setEffectiveDates(prev => ({
      ...prev,
      [section]: date
    }));
  };

  const handleSaveSection = (section) => {
    const today = new Date().toISOString().slice(0, 10);
    const effectiveDate = effectiveDates[section];
    
    if (effectiveDate < today) {
      alert('Effective date cannot be in the past!');
      return;
    }

    if (section === 'pt') {
      const currentState = rates.pt.currentState;
      const existingEntry = history.pt[currentState].find(entry => entry.date === effectiveDate);
      if (existingEntry) {
        const confirmUpdate = window.confirm(
          `An entry already exists for ${currentState} on ${effectiveDate}. This will update the existing entry. Continue?`
        );
        if (!confirmUpdate) return;
      }

      const newEntry = {
        id: Date.now(),
        date: effectiveDate,
        changes: `Updated ${currentState} PT rates`,
        rates: { slabs: [...rates.pt.states[currentState]] }
      };

      const updatedHistory = existingEntry 
        ? history.pt[currentState].map(entry => entry.date === effectiveDate ? newEntry : entry)
        : [...history.pt[currentState], newEntry].sort((a, b) => new Date(b.date) - new Date(a.date));

      setHistory(prev => ({
        ...prev,
        pt: {
          ...prev.pt,
          [currentState]: updatedHistory
        }
      }));

      alert(`${currentState} PT rates saved successfully!`);
    } else {
      const existingEntry = history[section].find(entry => entry.date === effectiveDate);
      if (existingEntry) {
        const confirmUpdate = window.confirm(
          `An entry already exists for ${effectiveDate}. This will update the existing entry. Continue?`
        );
        if (!confirmUpdate) return;
      }

      const newEntry = {
        id: Date.now(),
        date: effectiveDate,
        changes: `Updated ${section.toUpperCase()} rates`,
        rates: { ...rates[section] }
      };

      const updatedHistory = existingEntry 
        ? history[section].map(entry => entry.date === effectiveDate ? newEntry : entry)
        : [...history[section], newEntry].sort((a, b) => new Date(b.date) - new Date(a.date));

      setHistory(prev => ({
        ...prev,
        [section]: updatedHistory
      }));

      alert(`${section.toUpperCase()} rates saved successfully!`);
    }
  };

  const handleViewHistory = (section) => {
    setSelectedSection(section);
    setShowHistoryModal(true);
  };

  const handlePTStateChange = (state) => {
    setRates(prev => ({
      ...prev,
      pt: { ...prev.pt, currentState: state }
    }));
  };

  const handlePTRateChange = (index, field, value) => {
    const currentState = rates.pt.currentState;
    const newSlabs = [...rates.pt.states[currentState]];
    newSlabs[index] = { ...newSlabs[index], [field]: parseFloat(value) || 0 };
    setRates(prev => ({
      ...prev,
      pt: {
        ...prev.pt,
        states: {
          ...prev.pt.states,
          [currentState]: newSlabs
        }
      }
    }));
  };

  const handleIncomeTaxSlabChange = (regime, index, field, value) => {
    const newSlabs = [...rates.incomeTax.slabs[regime]];
    newSlabs[index] = { ...newSlabs[index], [field]: parseFloat(value) || 0 };
    setRates(prev => ({
      ...prev,
      incomeTax: {
        ...prev.incomeTax,
        slabs: {
          ...prev.incomeTax.slabs,
          [regime]: newSlabs
        }
      }
    }));
  };

  const handleAddPTSlab = () => {
    const currentState = rates.pt.currentState;
    const newSlabs = [...rates.pt.states[currentState], { min: 0, max: Infinity, rate: 0 }];
    setRates(prev => ({
      ...prev,
      pt: {
        ...prev.pt,
        states: {
          ...prev.pt.states,
          [currentState]: newSlabs
        }
      }
    }));
  };

  const handleDeletePTSlab = (index) => {
    const currentState = rates.pt.currentState;
    if (rates.pt.states[currentState].length > 1) {
      const newSlabs = rates.pt.states[currentState].filter((_, i) => i !== index);
      setRates(prev => ({
        ...prev,
        pt: {
          ...prev.pt,
          states: {
            ...prev.pt.states,
            [currentState]: newSlabs
          }
        }
      }));
    }
  };

  const handleAddIncomeTaxSlab = (regime) => {
    const newSlabs = [...rates.incomeTax.slabs[regime], { min: 0, max: Infinity, rate: 0 }];
    setRates(prev => ({
      ...prev,
      incomeTax: {
        ...prev.incomeTax,
        slabs: {
          ...prev.incomeTax.slabs,
          [regime]: newSlabs
        }
      }
    }));
  };

  const handleDeleteIncomeTaxSlab = (regime, index) => {
    if (rates.incomeTax.slabs[regime].length > 1) {
      const newSlabs = rates.incomeTax.slabs[regime].filter((_, i) => i !== index);
      setRates(prev => ({
        ...prev,
        incomeTax: {
          ...prev.incomeTax,
          slabs: {
            ...prev.incomeTax.slabs,
            [regime]: newSlabs
          }
        }
      }));
    }
  };

  const handleSurchargeChange = (regime, index, field, value) => {
    const newSurcharge = [...rates.incomeTax.surcharge[regime]];
    newSurcharge[index] = { ...newSurcharge[index], [field]: parseFloat(value) || 0 };
    setRates(prev => ({
      ...prev,
      incomeTax: {
        ...prev.incomeTax,
        surcharge: {
          ...prev.incomeTax.surcharge,
          [regime]: newSurcharge
        }
      }
    }));
  };

  const handleAddSurchargeSlab = (regime) => {
    const newSurcharge = [...rates.incomeTax.surcharge[regime], { min: 0, max: Infinity, rate: 0 }];
    setRates(prev => ({
      ...prev,
      incomeTax: {
        ...prev.incomeTax,
        surcharge: {
          ...prev.incomeTax.surcharge,
          [regime]: newSurcharge
        }
      }
    }));
  };

  const handleDeleteSurchargeSlab = (regime, index) => {
    if (rates.incomeTax.surcharge[regime].length > 1) {
      const newSurcharge = rates.incomeTax.surcharge[regime].filter((_, i) => i !== index);
      setRates(prev => ({
        ...prev,
        incomeTax: {
          ...prev.incomeTax,
          surcharge: {
            ...prev.incomeTax.surcharge,
            [regime]: newSurcharge
          }
        }
      }));
    }
  };

  const handleAddNewState = () => {
    if (!newStateName.trim()) {
      alert('Please enter a state name');
      return;
    }

    const stateName = newStateName.trim();
    
    // Check if state already exists
    if (rates.pt.states[stateName]) {
      alert('State already exists!');
      return;
    }

    // Add new state with default slabs
    const newState = {
      min: 0,
      max: Infinity,
      rate: 0
    };

    setRates(prev => ({
      ...prev,
      pt: {
        ...prev.pt,
        states: {
          ...prev.pt.states,
          [stateName]: [newState]
        }
      }
    }));

    // Add to history
    setHistory(prev => ({
      ...prev,
      pt: {
        ...prev.pt,
        [stateName]: [
          {
            id: Date.now(),
            date: new Date().toISOString().slice(0, 10),
            changes: `Initial ${stateName} PT rates setup`,
            rates: { slabs: [newState] }
          }
        ]
      }
    }));

    // Switch to new state
    setRates(prev => ({
      ...prev,
      pt: { ...prev.pt, currentState: stateName }
    }));

    setNewStateName('');
    setShowAddStateModal(false);
    alert(`${stateName} state added successfully!`);
  };


  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          Statutory Rates Configuration
        </h2>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Left Column */}
        <div className="space-y-6">

        {/* PF Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Provident Fund (PF)</h3>
            <div className="flex space-x-2">
              <button
                onClick={() => handleViewHistory('pf')}
                className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
              >
                History
              </button>
              <button
                onClick={() => handleSaveSection('pf')}
                className="px-3 py-1 text-sm rh-btn-primary rounded hover:opacity-95"
              >
                Save
              </button>
            </div>
          </div>

          {/* Effective Date */}
          <div className="mb-4 p-3 bg-redhalo-mint/40 border border-redhalo-teal/50 rounded">
            <label className="block text-sm font-medium text-redhalo-navy-dark mb-1">
              Effective Date *
            </label>
            <DatePicker
              value={effectiveDates.pf}
              onChange={(e) => handleEffectiveDateChange('pf', e.target.value)}
              min={new Date().toISOString().slice(0, 10)}
              className="px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
            />
          </div>

          <div className="max-h-96 overflow-y-auto space-y-4">
            {/* Basic PF Rates */}
            <div>
              <h4 className="text-sm font-medium text-gray-800 mb-2">Basic PF Rates</h4>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Employee Share (%)
                  </label>
                  <input
                    type="number"
                    value={rates.pf.employeeShare}
                    onChange={(e) => handleRateChange('pf', 'employeeShare', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Employer Share (%)
                  </label>
                  <input
                    type="number"
                    value={rates.pf.employerShare}
                    onChange={(e) => handleRateChange('pf', 'employerShare', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Ceiling (₹)
                  </label>
                  <input
                    type="number"
                    value={rates.pf.ceiling}
                    onChange={(e) => handleRateChange('pf', 'ceiling', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
                  />
                </div>
              </div>
            </div>

            {/* PF Bifurcation */}
            <div className="bg-redhalo-mint/40 p-3 rounded border border-redhalo-teal/50">
              <h4 className="text-sm font-medium text-redhalo-navy mb-2">PF Bifurcation (Employer Share)</h4>
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-redhalo-navy-dark mb-1">
                    EPF Rate (%)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={rates.pf.epf}
                    onChange={(e) => handleRateChange('pf', 'epf', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
                  />
                  <p className="text-xs text-redhalo-navy mt-1">Employee Provident Fund</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-redhalo-navy-dark mb-1">
                    EPS Rate (%)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={rates.pf.eps}
                    onChange={(e) => handleRateChange('pf', 'eps', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
                  />
                  <p className="text-xs text-redhalo-navy mt-1">Employee Pension Scheme</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-redhalo-navy-dark mb-1">
                    Admin Charges (%)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={rates.pf.adminCharges}
                    onChange={(e) => handleRateChange('pf', 'adminCharges', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
                  />
                  <p className="text-xs text-redhalo-navy mt-1">0.5% or ₹500 minimum per month</p>
                </div>
                <div>
                  <label className="block text-xs font-medium text-redhalo-navy-dark mb-1">
                    EDLI Rate (%)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={rates.pf.edliRate}
                    onChange={(e) => handleRateChange('pf', 'edliRate', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-redhalo-red/35"
                  />
                  <p className="text-xs text-redhalo-navy mt-1">Employee Deposit Linked Insurance</p>
                </div>
              </div>
              <div className="mt-2 p-2 bg-white rounded border border-redhalo-teal/50">
                <p className="text-xs text-redhalo-navy-dark">
                  <strong>Total Employer Share:</strong> {rates.pf.epf + rates.pf.eps + rates.pf.adminCharges + rates.pf.edliRate}%
                  {Math.abs((rates.pf.epf + rates.pf.eps + rates.pf.adminCharges + rates.pf.edliRate) - rates.pf.employerShare) > 0.01 && (
                    <span className="text-red-600 ml-1">⚠️ Does not match employer share ({rates.pf.employerShare}%)</span>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>


        {/* Gratuity Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Gratuity</h3>
            <div className="flex space-x-2">
              <button
                onClick={() => handleViewHistory('gratuity')}
                className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
              >
                History
              </button>
              <button
                onClick={() => handleSaveSection('gratuity')}
                className="px-3 py-1 text-sm bg-orange-600 text-white rounded hover:bg-orange-700"
              >
                Save
              </button>
            </div>
          </div>

          {/* Effective Date */}
          <div className="mb-4 p-3 bg-orange-50 border border-orange-200 rounded">
            <label className="block text-sm font-medium text-orange-800 mb-1">
              Effective Date *
            </label>
            <DatePicker
              label="Effective Date"
              required
              value={effectiveDates.gratuity}
              onChange={(e) => handleEffectiveDateChange('gratuity', e.target.value)}
              min={new Date().toISOString().slice(0, 10)}
              className="px-2 py-1 border border-orange-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
            />
          </div>

          <div className="max-h-96 overflow-y-auto">
            <div>
              <label className="block text-xs font-medium text-gray-700 mb-1">
                Rate (%)
              </label>
              <input
                type="number"
                step="0.01"
                value={rates.gratuity.rate}
                onChange={(e) => handleRateChange('gratuity', 'rate', e.target.value)}
                className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
              />
              <p className="text-xs text-gray-500 mt-1">Percentage of basic salary per year of service</p>
            </div>
          </div>
        </div>

        {/* Old Regime Tax Card */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Old Regime Tax</h3>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleViewHistory('incomeTaxOld')}
                  className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                >
                  History
                </button>
                <button
                  onClick={() => handleSaveSection('incomeTaxOld')}
                  className="px-3 py-1 text-sm bg-gray-600 text-white rounded hover:bg-gray-700"
                >
                  Save
                </button>
              </div>
            </div>

            {/* Effective Date */}
            <div className="mb-4 p-3 bg-gray-50 border border-gray-200 rounded">
              <label className="block text-sm font-medium text-gray-800 mb-1">
                Effective Date *
              </label>
              <DatePicker
                label="Effective Date"
                required
                value={effectiveDates.incomeTaxOld || effectiveDates.incomeTax}
                onChange={(e) => handleEffectiveDateChange('incomeTaxOld', e.target.value)}
                min={new Date().toISOString().slice(0, 10)}
                className="px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-gray-500"
              />
            </div>

            <div className="max-h-96 overflow-y-auto space-y-4">
              {/* Cess Rate */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Education & Health Cess (%)
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={rates.incomeTax.cess}
                  onChange={(e) => handleRateChange('incomeTax', 'cess', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-gray-500"
                />
                <p className="text-xs text-gray-500 mt-1">4% over tax payable (FY 2024-25)</p>
              </div>

              {/* Tax Slabs */}
              <div className="bg-gray-50 p-3 rounded border border-gray-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-medium text-gray-800">Tax Slabs</h4>
                  <button
                    onClick={() => handleAddIncomeTaxSlab('old')}
                    className="px-2 py-1 text-xs bg-gray-600 text-white rounded hover:bg-gray-700"
                  >
                    + Add Slab
                  </button>
                </div>
                <div className="space-y-2">
                  {rates.incomeTax.slabs.old.map((slab, index) => (
                    <div key={index} className="bg-white p-2 rounded border border-gray-200">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs text-gray-700 font-medium">Slab {index + 1}</span>
                        {rates.incomeTax.slabs.old.length > 1 && (
                          <button
                            onClick={() => handleDeleteIncomeTaxSlab('old', index)}
                            className="text-red-600 hover:text-red-800 text-xs"
                          >
                            ✕ Delete
                          </button>
                        )}
                      </div>
                      <div className="grid grid-cols-3 gap-2 text-xs">
                        <div>
                          <label className="block text-gray-700 mb-1">Min Income (₹)</label>
                          <input
                            type="number"
                            value={slab.min}
                            onChange={(e) => handleIncomeTaxSlabChange('old', index, 'min', e.target.value)}
                            className="w-full px-1 py-1 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-gray-500"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-700 mb-1">Max Income (₹)</label>
                          <input
                            type="number"
                            value={slab.max === Infinity ? '' : slab.max}
                            onChange={(e) => handleIncomeTaxSlabChange('old', index, 'max', e.target.value === '' ? Infinity : e.target.value)}
                            placeholder="Above"
                            className="w-full px-1 py-1 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-gray-500"
                          />
                        </div>
                        <div>
                          <label className="block text-gray-700 mb-1">Tax Rate (%)</label>
                          <input
                            type="number"
                            value={slab.rate}
                            onChange={(e) => handleIncomeTaxSlabChange('old', index, 'rate', e.target.value)}
                            className="w-full px-1 py-1 border border-gray-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-gray-500"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Surcharge */}
              <div className="bg-yellow-50 p-3 rounded border border-yellow-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-medium text-yellow-800">Surcharge (Income above ₹50 lakh)</h4>
                  <button
                    onClick={() => handleAddSurchargeSlab('old')}
                    className="px-2 py-1 text-xs bg-yellow-600 text-white rounded hover:bg-yellow-700"
                  >
                    + Add Slab
                  </button>
                </div>
                <div className="space-y-2">
                  {rates.incomeTax.surcharge.old.map((slab, index) => (
                    <div key={index} className="bg-white p-2 rounded border border-yellow-200">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs text-yellow-700 font-medium">Surcharge Slab {index + 1}</span>
                        {rates.incomeTax.surcharge.old.length > 1 && (
                          <button
                            onClick={() => handleDeleteSurchargeSlab('old', index)}
                            className="text-red-600 hover:text-red-800 text-xs"
                          >
                            ✕ Delete
                          </button>
                        )}
                      </div>
                      <div className="grid grid-cols-3 gap-2 text-xs">
                        <div>
                          <label className="block text-yellow-700 mb-1">Min Income (₹)</label>
                          <input
                            type="number"
                            value={slab.min}
                            onChange={(e) => handleSurchargeChange('old', index, 'min', e.target.value)}
                            className="w-full px-1 py-1 border border-yellow-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-yellow-500"
                          />
                        </div>
                        <div>
                          <label className="block text-yellow-700 mb-1">Max Income (₹)</label>
                          <input
                            type="number"
                            value={slab.max === Infinity ? '' : slab.max}
                            onChange={(e) => handleSurchargeChange('old', index, 'max', e.target.value === '' ? Infinity : e.target.value)}
                            placeholder="Above"
                            className="w-full px-1 py-1 border border-yellow-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-yellow-500"
                          />
                        </div>
                        <div>
                          <label className="block text-yellow-700 mb-1">Surcharge Rate (%)</label>
                          <input
                            type="number"
                            value={slab.rate}
                            onChange={(e) => handleSurchargeChange('old', index, 'rate', e.target.value)}
                            className="w-full px-1 py-1 border border-yellow-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-yellow-500"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-yellow-600 mt-2">
                  * Surcharge applies to income above ₹50 lakh, levied on basic tax payable
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-6">
          {/* ESI Card */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Employee State Insurance (ESI)</h3>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleViewHistory('esi')}
                  className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                >
                  History
                </button>
                <button
                  onClick={() => handleSaveSection('esi')}
                  className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Save
                </button>
              </div>
            </div>

            {/* Effective Date */}
            <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded">
              <label className="block text-sm font-medium text-green-800 mb-1">
                Effective Date *
              </label>
              <DatePicker
                label="Effective Date"
                required
                value={effectiveDates.esi}
                onChange={(e) => handleEffectiveDateChange('esi', e.target.value)}
                min={new Date().toISOString().slice(0, 10)}
                className="px-2 py-1 border border-green-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
              />
            </div>

            <div className="max-h-96 overflow-y-auto">
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Employee Share (%)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={rates.esi.employeeShare}
                    onChange={(e) => handleRateChange('esi', 'employeeShare', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Employer Share (%)
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    value={rates.esi.employerShare}
                    onChange={(e) => handleRateChange('esi', 'employerShare', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Ceiling (₹)
                  </label>
                  <input
                    type="number"
                    value={rates.esi.ceiling}
                    onChange={(e) => handleRateChange('esi', 'ceiling', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>
                <div>
                  <label className="block text-xs font-medium text-gray-700 mb-1">
                    Cutoff (₹)
                  </label>
                  <input
                    type="number"
                    value={rates.esi.cutoff}
                    onChange={(e) => handleRateChange('esi', 'cutoff', e.target.value)}
                    className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* PT Card */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Professional Tax (PT)</h3>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleViewHistory('pt')}
                  className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                >
                  History
                </button>
                <button
                  onClick={() => handleSaveSection('pt')}
                  className="px-3 py-1 text-sm bg-purple-600 text-white rounded hover:bg-purple-700"
                >
                  Save
                </button>
              </div>
            </div>

            {/* Effective Date */}
            <div className="mb-4 p-3 bg-purple-50 border border-purple-200 rounded">
              <label className="block text-sm font-medium text-purple-800 mb-1">
                Effective Date *
              </label>
              <DatePicker
                label="Effective Date"
                required
                value={effectiveDates.pt}
                onChange={(e) => handleEffectiveDateChange('pt', e.target.value)}
                min={new Date().toISOString().slice(0, 10)}
                className="px-2 py-1 border border-purple-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-purple-500"
              />
            </div>

            <div className="max-h-96 overflow-y-auto space-y-4">
              {/* State Selection */}
              <div>
                <div className="flex items-center justify-between mb-1">
                  <label className="block text-xs font-medium text-gray-700">
                    State
                  </label>
                  <button
                    onClick={() => setShowAddStateModal(true)}
                    className="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
                  >
                    + Add State
                  </button>
                </div>
                <select
                  value={rates.pt.currentState}
                  onChange={(e) => handlePTStateChange(e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-purple-500"
                >
                  {Object.keys(rates.pt.states).map(state => (
                    <option key={state} value={state}>{state}</option>
                  ))}
                </select>
              </div>

              {/* PT Slabs */}
              <div className="bg-purple-50 p-3 rounded border border-purple-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-medium text-purple-900">Professional Tax Slabs ({rates.pt.currentState})</h4>
                  <button
                    onClick={handleAddPTSlab}
                    className="px-2 py-1 text-xs bg-purple-600 text-white rounded hover:bg-purple-700"
                  >
                    + Add Slab
                  </button>
                </div>
                <div className="space-y-2">
                  {rates.pt.states[rates.pt.currentState].map((slab, index) => (
                    <div key={index} className="bg-white p-2 rounded border border-purple-200">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs text-purple-700 font-medium">Slab {index + 1}</span>
                        {rates.pt.states[rates.pt.currentState].length > 1 && (
                          <button
                            onClick={() => handleDeletePTSlab(index)}
                            className="text-red-600 hover:text-red-800 text-xs"
                          >
                            ✕ Delete
                          </button>
                        )}
                      </div>
                      <div className="grid grid-cols-3 gap-2 text-xs">
                        <div>
                          <label className="block text-purple-700 mb-1">Min Salary (₹)</label>
                          <input
                            type="number"
                            value={slab.min}
                            onChange={(e) => handlePTRateChange(index, 'min', e.target.value)}
                            className="w-full px-1 py-1 border border-purple-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-purple-500"
                          />
                        </div>
                        <div>
                          <label className="block text-purple-700 mb-1">Max Salary (₹)</label>
                          <input
                            type="number"
                            value={slab.max === Infinity ? '' : slab.max}
                            onChange={(e) => handlePTRateChange(index, 'max', e.target.value === '' ? Infinity : e.target.value)}
                            placeholder="Above"
                            className="w-full px-1 py-1 border border-purple-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-purple-500"
                          />
                        </div>
                        <div>
                          <label className="block text-purple-700 mb-1">Tax Amount (₹)</label>
                          <input
                            type="number"
                            value={slab.rate}
                            onChange={(e) => handlePTRateChange(index, 'rate', e.target.value)}
                            className="w-full px-1 py-1 border border-purple-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-purple-500"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-purple-600 mt-2">
                  * Professional Tax rates vary by state. Edit individual slab values above.
                </p>
              </div>
            </div>
          </div>

          {/* New Regime Tax Card */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">New Regime Tax</h3>
              <div className="flex space-x-2">
                <button
                  onClick={() => handleViewHistory('incomeTaxNew')}
                  className="px-3 py-1 text-sm bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                >
                  History
                </button>
                <button
                  onClick={() => handleSaveSection('incomeTaxNew')}
                  className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                >
                  Save
                </button>
              </div>
            </div>

            {/* Effective Date */}
            <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded">
              <label className="block text-sm font-medium text-green-800 mb-1">
                Effective Date *
              </label>
              <DatePicker
                label="Effective Date"
                required
                value={effectiveDates.incomeTaxNew || effectiveDates.incomeTax}
                onChange={(e) => handleEffectiveDateChange('incomeTaxNew', e.target.value)}
                min={new Date().toISOString().slice(0, 10)}
                className="px-2 py-1 border border-green-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
              />
            </div>

            <div className="max-h-96 overflow-y-auto space-y-4">
              {/* Cess Rate */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Education & Health Cess (%)
                </label>
                <input
                  type="number"
                  step="0.01"
                  value={rates.incomeTax.cess}
                  onChange={(e) => handleRateChange('incomeTax', 'cess', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-1 focus:ring-green-500"
                />
                <p className="text-xs text-gray-500 mt-1">4% over tax payable (FY 2024-25)</p>
              </div>

              {/* Tax Slabs */}
              <div className="bg-green-50 p-3 rounded border border-green-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-medium text-green-800">Tax Slabs</h4>
                  <button
                    onClick={() => handleAddIncomeTaxSlab('new')}
                    className="px-2 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
                  >
                    + Add Slab
                  </button>
                </div>
                <div className="space-y-2">
                  {rates.incomeTax.slabs.new.map((slab, index) => (
                    <div key={index} className="bg-white p-2 rounded border border-green-200">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs text-green-700 font-medium">Slab {index + 1}</span>
                        {rates.incomeTax.slabs.new.length > 1 && (
                          <button
                            onClick={() => handleDeleteIncomeTaxSlab('new', index)}
                            className="text-red-600 hover:text-red-800 text-xs"
                          >
                            ✕ Delete
                          </button>
                        )}
                      </div>
                      <div className="grid grid-cols-3 gap-2 text-xs">
                        <div>
                          <label className="block text-green-700 mb-1">Min Income (₹)</label>
                          <input
                            type="number"
                            value={slab.min}
                            onChange={(e) => handleIncomeTaxSlabChange('new', index, 'min', e.target.value)}
                            className="w-full px-1 py-1 border border-green-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
                          />
                        </div>
                        <div>
                          <label className="block text-green-700 mb-1">Max Income (₹)</label>
                          <input
                            type="number"
                            value={slab.max === Infinity ? '' : slab.max}
                            onChange={(e) => handleIncomeTaxSlabChange('new', index, 'max', e.target.value === '' ? Infinity : e.target.value)}
                            placeholder="Above"
                            className="w-full px-1 py-1 border border-green-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
                          />
                        </div>
                        <div>
                          <label className="block text-green-700 mb-1">Tax Rate (%)</label>
                          <input
                            type="number"
                            value={slab.rate}
                            onChange={(e) => handleIncomeTaxSlabChange('new', index, 'rate', e.target.value)}
                            className="w-full px-1 py-1 border border-green-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-green-500"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Surcharge */}
              <div className="bg-yellow-50 p-3 rounded border border-yellow-200">
                <div className="flex items-center justify-between mb-2">
                  <h4 className="text-sm font-medium text-yellow-800">Surcharge (Income above ₹50 lakh)</h4>
                  <button
                    onClick={() => handleAddSurchargeSlab('new')}
                    className="px-2 py-1 text-xs bg-yellow-600 text-white rounded hover:bg-yellow-700"
                  >
                    + Add Slab
                  </button>
                </div>
                <div className="space-y-2">
                  {rates.incomeTax.surcharge.new.map((slab, index) => (
                    <div key={index} className="bg-white p-2 rounded border border-yellow-200">
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-xs text-yellow-700 font-medium">Surcharge Slab {index + 1}</span>
                        {rates.incomeTax.surcharge.new.length > 1 && (
                          <button
                            onClick={() => handleDeleteSurchargeSlab('new', index)}
                            className="text-red-600 hover:text-red-800 text-xs"
                          >
                            ✕ Delete
                          </button>
                        )}
                      </div>
                      <div className="grid grid-cols-3 gap-2 text-xs">
                        <div>
                          <label className="block text-yellow-700 mb-1">Min Income (₹)</label>
                          <input
                            type="number"
                            value={slab.min}
                            onChange={(e) => handleSurchargeChange('new', index, 'min', e.target.value)}
                            className="w-full px-1 py-1 border border-yellow-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-yellow-500"
                          />
                        </div>
                        <div>
                          <label className="block text-yellow-700 mb-1">Max Income (₹)</label>
                          <input
                            type="number"
                            value={slab.max === Infinity ? '' : slab.max}
                            onChange={(e) => handleSurchargeChange('new', index, 'max', e.target.value === '' ? Infinity : e.target.value)}
                            placeholder="Above"
                            className="w-full px-1 py-1 border border-yellow-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-yellow-500"
                          />
                        </div>
                        <div>
                          <label className="block text-yellow-700 mb-1">Surcharge Rate (%)</label>
                          <input
                            type="number"
                            value={slab.rate}
                            onChange={(e) => handleSurchargeChange('new', index, 'rate', e.target.value)}
                            className="w-full px-1 py-1 border border-yellow-300 rounded text-xs focus:outline-none focus:ring-1 focus:ring-yellow-500"
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <p className="text-xs text-yellow-600 mt-2">
                  * Surcharge applies to income above ₹50 lakh, levied on basic tax payable
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* History Modal */}
      {showHistoryModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl w-[90vw] max-w-4xl max-h-[90vh] flex flex-col">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <div className="flex items-center space-x-4">
                <h2 className="text-xl font-semibold text-gray-900">
                  {selectedSection === 'pt' ? 'Professional Tax Rate History' : `${selectedSection.toUpperCase()} Rate History`}
                </h2>
                {selectedSection === 'pt' && (
                  <select
                    value={ptHistoryState}
                    onChange={(e) => setPtHistoryState(e.target.value)}
                    className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-purple-500"
                  >
                    {Object.keys(rates.pt.states).map(state => (
                                            <option key={state?.id ?? state} value={state?.id ?? state}>
                        {state?.name ?? state}
                      </option>

                    ))}
                  </select>
                )}
              </div>
              <button
                onClick={() => setShowHistoryModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6 overflow-y-auto flex-1">
              <div className="space-y-4">
                {(selectedSection === 'pt' ? history.pt[ptHistoryState] : history[selectedSection]).map((entry) => (
                  <div key={entry.id} className="border border-gray-200 rounded-lg p-4">
                    <div className="flex items-center justify-between mb-3">
                      <div>
                        <h3 className="text-lg font-medium text-gray-900">
                          Effective Date: {formatDate(entry.date)}
                        </h3>
                        <p className="text-sm text-gray-600">{entry.changes}</p>
                      </div>
                      <div className="text-right">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                          entry.date === effectiveDates[selectedSection] ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                        }`}>
                          {entry.date === effectiveDates[selectedSection] ? 'Current' : 'Historical'}
                        </span>
                      </div>
                    </div>
                    
                    <div className="bg-gray-50 p-3 rounded">
                      {selectedSection === 'pf' && (
                        <div className="space-y-2 text-xs">
                          <div className="grid grid-cols-2 gap-2">
                            <div><strong>Employee Share:</strong> {entry.rates.employeeShare}%</div>
                            <div><strong>Employer Share:</strong> {entry.rates.employerShare}%</div>
                            <div><strong>Ceiling:</strong> ₹{entry.rates.ceiling?.toLocaleString()}</div>
                            <div><strong>EPF Rate:</strong> {entry.rates.epf}%</div>
                            <div><strong>EPS Rate:</strong> {entry.rates.eps}%</div>
                            <div><strong>Admin Charges:</strong> {entry.rates.adminCharges}%</div>
                            <div><strong>EDLI Rate:</strong> {entry.rates.edliRate}%</div>
                          </div>
                        </div>
                      )}
                      {selectedSection === 'esi' && (
                        <div className="space-y-2 text-xs">
                          <div className="grid grid-cols-2 gap-2">
                            <div><strong>Employee Share:</strong> {entry.rates.employeeShare}%</div>
                            <div><strong>Employer Share:</strong> {entry.rates.employerShare}%</div>
                            <div><strong>Ceiling:</strong> ₹{entry.rates.ceiling?.toLocaleString()}</div>
                            <div><strong>Cutoff:</strong> ₹{entry.rates.cutoff?.toLocaleString()}</div>
                          </div>
                        </div>
                      )}
                      {selectedSection === 'pt' && (
                        <div className="space-y-2 text-xs">
                          <div><strong>State:</strong> {ptHistoryState}</div>
                          <div><strong>Slabs:</strong></div>
                          <div className="ml-4 space-y-1">
                            {entry.rates.slabs?.map((slab, idx) => (
                              <div key={idx} className="text-gray-600">
                                ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: ₹{slab.rate}
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {selectedSection === 'gratuity' && (
                        <div className="space-y-2 text-xs">
                          <div><strong>Rate:</strong> {entry.rates.rate}%</div>
                          <div className="text-gray-600">Percentage of basic salary per year of service</div>
                        </div>
                      )}
                      {selectedSection === 'incomeTax' && (
                        <div className="space-y-2 text-xs">
                          <div><strong>Education & Health Cess:</strong> {entry.rates.cess}%</div>
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                              <div className="font-medium text-gray-800 mb-1">Old Regime Tax Slabs:</div>
                              <div className="space-y-1">
                                {entry.rates.slabs?.old?.map((slab, idx) => (
                                  <div key={idx} className="text-gray-600">
                                    ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                                  </div>
                                ))}
                              </div>
                              <div className="font-medium text-gray-800 mb-1 mt-2">Old Regime Surcharge:</div>
                              <div className="space-y-1">
                                {entry.rates.surcharge?.old?.map((slab, idx) => (
                                  <div key={idx} className="text-gray-600">
                                    ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                                  </div>
                                ))}
                              </div>
                            </div>
                            <div>
                              <div className="font-medium text-gray-800 mb-1">New Regime Tax Slabs:</div>
                              <div className="space-y-1">
                                {entry.rates.slabs?.new?.map((slab, idx) => (
                                  <div key={idx} className="text-gray-600">
                                    ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                                  </div>
                                ))}
                              </div>
                              <div className="font-medium text-gray-800 mb-1 mt-2">New Regime Surcharge:</div>
                              <div className="space-y-1">
                                {entry.rates.surcharge?.new?.map((slab, idx) => (
                                  <div key={idx} className="text-gray-600">
                                    ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {selectedSection === 'incomeTaxOld' && (
                        <div className="space-y-2 text-xs">
                          <div><strong>Education & Health Cess:</strong> {entry.rates.cess}%</div>
                          <div className="font-medium text-gray-800 mb-1">Tax Slabs:</div>
                          <div className="space-y-1">
                            {entry.rates.slabs?.map((slab, idx) => (
                              <div key={idx} className="text-gray-600">
                                ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                              </div>
                            ))}
                          </div>
                          <div className="font-medium text-gray-800 mb-1 mt-2">Surcharge:</div>
                          <div className="space-y-1">
                            {entry.rates.surcharge?.map((slab, idx) => (
                              <div key={idx} className="text-gray-600">
                                ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                      {selectedSection === 'incomeTaxNew' && (
                        <div className="space-y-2 text-xs">
                          <div><strong>Education & Health Cess:</strong> {entry.rates.cess}%</div>
                          <div className="font-medium text-gray-800 mb-1">Tax Slabs:</div>
                          <div className="space-y-1">
                            {entry.rates.slabs?.map((slab, idx) => (
                              <div key={idx} className="text-gray-600">
                                ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                              </div>
                            ))}
                          </div>
                          <div className="font-medium text-gray-800 mb-1 mt-2">Surcharge:</div>
                          <div className="space-y-1">
                            {entry.rates.surcharge?.map((slab, idx) => (
                              <div key={idx} className="text-gray-600">
                                ₹{slab.min?.toLocaleString()} - {slab.max === Infinity ? 'Above' : `₹${slab.max?.toLocaleString()}`}: {slab.rate}%
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              
              {(selectedSection === 'pt' ? history.pt[ptHistoryState] : history[selectedSection]).length === 0 && (
                <div className="text-center py-8">
                  <p className="text-gray-500">No rate history available</p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Add New State Modal */}
      {showAddStateModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl w-96 max-w-md">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">Add New State</h2>
              <button
                onClick={() => setShowAddStateModal(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            
            <div className="p-6">
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  State Name
                </label>
                <input
                  type="text"
                  value={newStateName}
                  onChange={(e) => setNewStateName(e.target.value)}
                  placeholder="Enter state name (e.g., Kerala)"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500"
                  onKeyPress={(e) => e.key === 'Enter' && handleAddNewState()}
                />
              </div>
              
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => setShowAddStateModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
                >
                  Cancel
                </button>
                <button
                  onClick={handleAddNewState}
                  className="px-4 py-2 text-sm font-medium text-white bg-purple-600 rounded-md hover:bg-purple-700"
                >
                  Add State
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default StatutoryRatesManager;
